<template>
  <v-autocomplete
    :value="value"
    :data-cy="dataCy"
    :items="list"
    clearable
    :loading="isLoading"
    :label="label"
    item-text="name"
    item-value="id"
    return-object
    disable-filtering
    @change="(v) => $emit('input', v)"
    @update:search-input="(v) => updateSearch(v)"
  />
</template>

<script>
import { companyTable } from '../services/companies';

export default {
  props: {
    value: {
      type: Object,
      default: null,
    },
    label: {
      type: String,
      default: 'Company*',
    },
    dataCy: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      list: [],
      search: '',
      isLoading: false,
    };
  },
  async mounted() {
    await this.updateList('');
  },
  methods: {
    async updateList(search) {
      if (this.isLoading) return;

      this.isLoading = true;
      const { data } = await companyTable(search);
      this.list = data?.results;
      this.isLoading = false;
    },
    async updateSearch(search) {
      if (!search || search === this.search) return;
      this.search = search;
      // TODO when the emails are moved off of companies
      // we will only search on name
      await this.updateList(search);
    },
  },
};
</script>

<style>

</style>
